import { createContext } from 'react';

const ReaderSettingsModifiersContext = createContext({
  setPalette: () => {},
  resetReaderStyling: () => {},
});

export default ReaderSettingsModifiersContext;
